import { useState, useEffect } from 'react';

export const useDeviceCollapse = () => {
  const getDeviceInfo = () => {
    const width = window.innerWidth || document.documentElement.clientWidth;
    return {
      isMobile: width < 768,
      isTablet: width >= 768 && width < 1200,
      shouldCollapse: width < 1200,
    };
  };

  const [deviceInfo, setDeviceInfo] = useState(getDeviceInfo);
  const [collapsed, setCollapsed] = useState(deviceInfo.shouldCollapse);

  useEffect(() => {
    const handleResize = () => {
      const newDeviceInfo = getDeviceInfo();
      setDeviceInfo(newDeviceInfo);

      if (newDeviceInfo.shouldCollapse) {
        setCollapsed(true);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const setCollapsedSafe = (value: boolean) => {
    if (!value || !deviceInfo.shouldCollapse) {
      setCollapsed(value);
    }
  };

  return {
    collapsed,
    setCollapsed: setCollapsedSafe,
    ...deviceInfo,
  };
};
